import { Query } from '@apollo/client/react/components';
import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { LensQuery, LensQueryVariables, LensDocument } from '../../../../../gen-src/queries';
import { CenteredFadeInSpinner, CenteredMessage } from '../../../data-catalog-shared';
import { RenderQueryResult } from '../renderQueryResult';
import { createRenderDataWithErrorFunction, renderError, renderNoData } from '../widgets/ErrorMessageWidgets';


export type LensQueryWrapperProps = Readonly<{
  vizportalUrlId: string;
  children: (result: Unpacked<LensQuery['lenses']>) => React.ReactNode;
}>;

export const LensQueryWrapper = (props: LensQueryWrapperProps): JSX.Element => {
  const renderLensData = (data: LensQuery): React.ReactNode => {
    const lens = data.lenses ? data.lenses[0] : null;
    return lens ? props.children(lens) : <CenteredMessage message={Messages.ErrorItemNotFound()} />
  }

  return <Query<LensQuery, LensQueryVariables>
    query={LensDocument}
    variables={{ vizportalUrlId: props.vizportalUrlId }}
  >{(result) => <RenderQueryResult result={result} renderers={{
    renderLoading: CenteredFadeInSpinner,
    renderData: renderLensData,
    renderNoData: renderNoData,
    renderDataWithError: createRenderDataWithErrorFunction(renderLensData),
    renderError: renderError,
  }} />}</Query>;
}
